<!-- src/components/PriceSetFilter.vue -->
<template>
  <div class="qset">
    <!-- mode switch -->
    <div class="qset-modes">
      <el-radio-group v-model="pendingMode" size="mini">
        <el-radio-button label="all">All</el-radio-button>
        <el-radio-button label="with">With price</el-radio-button>
        <el-radio-button label="zero">Zero price</el-radio-button>
      </el-radio-group>
    </div>

    <!-- values list -->
    <div class="qset-list">
      <el-checkbox-group v-model="pending" :disabled="pendingMode !== 'all'">
        <el-checkbox
          v-for="v in options"
          :key="v"
          :label="v"
          class="qset-item"
        >{{ fmt(v) }}</el-checkbox>
      </el-checkbox-group>
    </div>

    <div class="qset-footer">
      <span class="qset-link" @click="onConfirm">Confirm</span>
      <span class="qset-link" @click="onReset">Reset</span>
    </div>
  </div>
</template>

<script>
import formatMoney from 'accounting-js/lib/formatMoney.js'

export default {
  name: 'PriceSetFilter',
  data() {
    return {
      params: null,
      field: null,
      options: [],
      pending: [],
      applied: [],
      pendingMode: 'all',   // 'all' | 'with' | 'zero'
      appliedMode: 'all'
    }
  },
  methods: {
    fmt(v) {
      return formatMoney(Number(v || 0), { symbol: '', precision: 2, thousand: ',', decimal: '.' })
    },
    resolveField() {
      const p = this.params || {}
      const f = (p.colDef && p.colDef.field) || (p.column && p.column.getColId())
      if (f) this.field = f
      return f
    },
    buildOptions() {
      if (!this.params || !this.params.api) return
      const p = this.params
      const field = this.resolveField()
      if (!field) return

      if (p.filterParams && typeof p.filterParams.valuesGetter === 'function') {
        let vals = p.filterParams.valuesGetter({ api: p.api, colDef: p.colDef, field }) || []
        this.options = vals.slice().sort((a, b) => a - b)
        this.pending = this.pending.filter(v => this.options.indexOf(v) !== -1)
        return
      }

      const uniq = Object.create(null)
      p.api.forEachNodeAfterFilter(node => {
        if (!node || !node.data) return
        const n = Number(node.data[field])
        if (!isNaN(n)) uniq[n] = true
      })
      if (!Object.keys(uniq).length) {
        p.api.forEachNode(node => {
          if (!node || !node.data) return
          const n = Number(node.data[field])
          if (!isNaN(n)) uniq[n] = true
        })
      }
      this.options = Object.keys(uniq).map(k => Number(k)).sort((a, b) => a - b)
      this.pending = this.pending.filter(v => uniq[v] || uniq[String(v)])
    },

    // ag-Grid hooks
    init(params) { this.params = params; this.buildOptions() },
    afterGuiAttached() { this.buildOptions() },
    onNewRowsLoaded() { this.buildOptions() },
isFilterActive() {
      return this.appliedMode !== 'all' || this.applied.length > 0
    },
    
    doesFilterPass(params) {
      // support both wrappers
      const node = (params && params.node) ? params.node : params
      const f = this.field || this.resolveField()
      if (!f) return true

      const raw = node && node.data ? node.data[f] : null
      const v = Number(raw)
      if (Number.isNaN(v)) return false

      if (this.appliedMode === 'zero') return v === 0
      if (this.appliedMode === 'with') return v > 0

      // explicit selections in 'all' mode
      if (!this.applied.length) return true
      return this.applied.includes(v)
    },

    getModel() {
      return (this.appliedMode !== 'all' || this.applied.length)
        ? { type: 'priceSet', mode: this.appliedMode, values: this.applied.slice() }
        : null
    },

    setModel(m) {
      const mode = m && m.mode ? m.mode : 'all'
      const vals = (m && Array.isArray(m.values)) ? m.values.slice() : []
      this.appliedMode = mode
      this.pendingMode = mode
      this.applied = vals
      this.pending = (mode === 'all') ? vals.slice() : []
    },
onConfirm() {
      this.appliedMode = this.pendingMode
      this.applied = (this.appliedMode === 'all') ? this.pending.slice() : []
      this.params?.filterChangedCallback && this.params.filterChangedCallback()
    },

    onReset() {
      this.pending = []
      this.applied = []
      this.pendingMode = 'all'
      this.appliedMode = 'all'
      this.params?.filterChangedCallback && this.params.filterChangedCallback()
    }
    // ui actions
   /*  onConfirm() {
      this.appliedMode = this.pendingMode
      this.applied = (this.appliedMode === 'all') ? this.pending.slice() : []
      this.params && this.params.filterChangedCallback && this.params.filterChangedCallback()
    },
    onReset() {
      this.pending = []
      this.applied = []
      this.pendingMode = 'all'
      this.appliedMode = 'all'
      this.params && this.params.filterChangedCallback && this.params.filterChangedCallback()
    } */
  },
  watch: {
    pendingMode(n) { if (n !== 'all') this.pending = [] }
  }
}
</script>

<style scoped>
.qset { min-width: 180px; padding: 6px; }
.qset-modes { margin-bottom: 8px; }
.qset-list { max-height: 220px; overflow-y: auto; overflow-x: hidden; padding-right: 4px; }
.qset-item { display: block !important; margin: 4px 0; white-space: nowrap; }
.qset-footer { margin-top: 8px; display: flex; gap: 10px; font-size: 12px; color: #409EFF; user-select: none; }
.qset-link { cursor: pointer; }
.qset-link:hover { text-decoration: underline; }
</style>
